<template>
    <div>
        
    </div>
</template>
<script>
    import { encryptLong, syShopSign } from '@/utils/rsaEncrypt'
    export default {
        name: 'Index',
        data() {
            return {
               
            }
        },
        methods: {
            getOpenMinChengXuLink() {
                let url = '/sy/aboutUs/getScheme';
                const timeStamp = new Date().getTime();
                const sySign = syShopSign();
                const CheckCsrf = encryptLong(sySign + timeStamp);
                this.axios.get(url,{headers:{'TimeStamp': timeStamp, 'CheckCsrf': CheckCsrf,'Content-Type':'application/x-www-form-urlencoded'}}).then(res => {
                    if(res.data.data){
                        window.location.href = res.data.data;
                    }
                console.info("----"+res.data.data);
                    // window.location.href = res.data.data;   
                })
            },
        },
        created() {
            console.info("---")
            this.getOpenMinChengXuLink();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Index.vue